// Shared button used across every RSVP flow screen. Preserves the
// existing .button.w-inline-block / .button-txt classes so Webflow's
// global typography applies unchanged.
//
// variant: "primary" — white filled
//          "outline" — transparent with white border
//          "ghost"   — transparent with muted border, used for Back links

const VARIANT_STYLES = {
  primary: {
    background: "var(--black)",
    color: "var(--white)",
    border: "1px solid var(--black)",
  },
  outline: {
    background: "transparent",
    color: "var(--black)",
    border: "1px solid var(--black)",
  },
  ghost: {
    background: "transparent",
    color: "var(--black)",
    border: "1px solid rgba(0,0,0,0.35)",
    opacity: 0.75,
  },
};

const ActionButton = ({
  variant = "primary",
  disabled = false,
  onClick,
  type = "button",
  children,
  style,
  ...rest
}) => {
  const base = VARIANT_STYLES[variant] || VARIANT_STYLES.primary;
  const merged = {
    ...base,
    padding: "15px 30px",
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.6 : base.opacity ?? 1,
    ...style,
  };
  return (
    <button
      type={type}
      className="button w-inline-block"
      disabled={disabled}
      onClick={onClick}
      style={merged}
      {...rest}
    >
      <div className="button-txt">{children}</div>
    </button>
  );
};

export default ActionButton;
